import * as React from 'react'

import { Controller } from 'react-hook-form'

import Localization from '~/client/src/shared/localization/LocalizationManager'

import LocationPickerField from '../../LocationPicker/LocationPickerField'
import { LocationFieldConfig } from '../types'

interface LocationFieldProps {
  field: LocationFieldConfig
  control: any
  error?: string
  hideHelperText?: boolean
}

const LocationField: React.FC<LocationFieldProps> = ({
  field,
  control,
  error,
  hideHelperText,
}) => (
  <Controller
    name={field.name}
    control={control}
    defaultValue={field.defaultValue}
    rules={{
      required: field.required
        ? Localization.translator.requiredFieldCannotBeEmpty
        : false,
    }}
    render={({ field: { onChange, value } }) => (
      <LocationPickerField
        className="tw:overflow-hidden"
        label={field.label || field.name}
        selectedId={value}
        onSelect={onChange}
        onReset={() => onChange(undefined)}
        isRequired={field.required}
        isReadOnly={field.readOnly || field.displayOnly}
        isDisabled={field.disabled}
        isValid={!error}
        validationMessage={error}
        isHelperTextHidden={hideHelperText}
        isTopMarginForced
      />
    )}
  />
)

export default LocationField
